import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import styled from '@emotion/styled';
import { shadow1 } from '../styles/util';
import { fromThemeColors } from '../Theme';
export var StyledDatepicker = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tdisplay: flex;\n\tborder: 1px solid ", ";\n\tborder-radius: 4px;\n\tbackground-color: ", ";\n\tbox-shadow: ", ";\n\tmargin-top: 2px;\n"])), fromThemeColors('border'), fromThemeColors('flyoverBackground'), shadow1.boxShadow);